import { useSearchParams } from 'next/navigation';
import { useUnmount } from 'usehooks-ts';

import { type ListingsRangeFilter } from '@/features/listing/types/listing-filters-types';
import InputRange from '@/ui/form-elements/input-range-slider/input-range';

interface ListingBudgetFilterProps {
  filter: ListingsRangeFilter;
  setFilterLink: (link: { pathname: string; searchParams: URLSearchParams }) => void;
  filterLink: {
    pathname: string;
    searchParams: URLSearchParams;
  }
}

export default function ListingFilterRange(props: ListingBudgetFilterProps) {
  const {
    filter,
    filterLink,
    setFilterLink,
  } = props;

  const searchParams = useSearchParams();

  const initialMinValue = filter.options.min.value;
  const initialMaxValue = filter.options.max.value;

  const creteNewSearchParams = (min: string, max: string) => {
    if (
      Number(min) === filter.options.min.defaultValue
      && Number(max) === filter.options.max.defaultValue
    ) {
      filterLink.searchParams.delete(filter.options.min.name);
      filterLink.searchParams.delete(filter.options.max.name);
    } else {
      filterLink.searchParams.set(filter.options.min.name, min);
      filterLink.searchParams.set(filter.options.max.name, max);
    }

    setFilterLink({
      pathname: filterLink.pathname,
      searchParams: filterLink.searchParams,
    });
  };

  useUnmount(() => {
    setFilterLink({
      pathname: filterLink.pathname,
      searchParams: new URLSearchParams(searchParams.toString()),
    });
  });

  return (
    <InputRange
      range
      step={filter.step}
      min={filter.options.min.defaultValue}
      max={filter.options.max.defaultValue}
      ariaLabelMin={filter.options.min.ariaLabel}
      ariaLabelMax={filter.options.max.ariaLabel}
      value={[
        initialMinValue,
        initialMaxValue,
      ]}
      allowCross={false}
      onChange={creteNewSearchParams}
    />
  );
}
